import { TeamOutput, Order } from 'gql/types';
import { useSort } from 'modules/common/hooks';
import { TeamListSort } from 'modules/donor/components/TeamsTable/interfaces';
import { useMemo } from 'react';

export const useTeamsSort = (teams: TeamOutput[]) => {
  const sort = useSort<TeamListSort>();

  const sortedTeams = useMemo(() => {
    const option = sort.options[0];
    if (!option) return teams;

    return [...teams].sort((a, b) => {
      if (option.fieldName === TeamListSort.Title) {
        const result = a.title.localeCompare(b.title);
        return option.order === Order.Asc ? result : -result;
      }
      if (option.fieldName === TeamListSort.Total) {
        const aLen = a.donors?.length ?? 0;
        const bLen = b.donors?.length ?? 0;
        return option.order === Order.Asc ? aLen - bLen : bLen - aLen;
      }
      return 0;
    });
  }, [teams, sort.options]);

  return { sort, sortedTeams };
};
